import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFolder2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"folder-2"} maskId="square-filled-radius-0-stroke-1-IconFolder2"><path d="M2 9V3H10.0881L12.1992 5H22V9H2Z" fill="currentColor"/><path d="M2 10V20H22V10H2Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconFolder2;
